// import { Box, Typography, useTheme, Grid } from '@mui/material';
// import React from 'react';
// import { FaExclamationCircle, FaFirstAid, FaShieldAlt, FaStickyNote } from 'react-icons/fa';
// import { SectionProps, CarePlanFieldPath } from '../../../../types/ndisSection/carePlanInfoTypes';
// import { CareTextField, SectionHeader } from '../Components';

// const getNestedValue = (obj: any, path: string): string => {
//   if (!obj) return 'Not provided';
//   const keys = path.split('.');
//   let current = obj;
//   for (const key of keys) {
//     if (current && typeof current === 'object' && key in current) {
//       current = current[key];
//     } else {
//       return 'Not provided';
//     }
//   }
//   return current || 'Not provided';
// };

// const ContingencyPlanSection: React.FC<SectionProps> = ({
//   editMode,
//   isMobile,
//   handleEditToggle,
//   handleSubmit,
//   handleCancel,
//   control,
//   errors,
//   getValues,
//   carePlan
// }) => {
//   const theme = useTheme();
//   const spacing = isMobile ? 1 : 2;

//   const fields: { label: string; name: CarePlanFieldPath; icon: JSX.Element }[] = [
//     {
//       label: 'Scenario',
//       name: 'ContingencyAndDisasterPlan.Scenario' as CarePlanFieldPath,
//       icon: <FaFirstAid />
//     },
//     {
//       label: 'Risk Level',
//       name: 'ContingencyAndDisasterPlan.RiskLevel' as CarePlanFieldPath,
//       icon: <FaShieldAlt />
//     },
//     {
//       label: 'Immediate Action',
//       name: 'ContingencyAndDisasterPlan.ImmediateAction' as CarePlanFieldPath,
//       icon: <FaStickyNote />
//     },
//     {
//       label: 'Ongoing Action',
//       name: 'ContingencyAndDisasterPlan.OngoingAction' as CarePlanFieldPath,
//       icon: <FaStickyNote />
//     }
//   ];

//   return (
//     <Box
//       sx={{
//         backgroundColor: theme.palette.background.paper,
//         borderRadius: 2,
//         boxShadow: theme.shadows[1],
//         overflow: 'hidden',
//         width: '100%',
//         maxWidth: '100%',
//         mx: 'auto'
//       }}
//     >
//       <SectionHeader
//         icon={<FaExclamationCircle size={isMobile ? 16 : 20} />}
//         title="Contingency & Disaster Plan"
//         color={theme.palette.warning.dark}
//         editMode={editMode}
//         handleEditToggle={handleEditToggle}
//         handleSubmit={handleSubmit}
//         handleCancel={handleCancel}
//         getValues={getValues}
//       />

//       <Box sx={{ p: isMobile ? 1 : 2 }}>
//         {editMode ? (
//           <Grid container spacing={spacing}>
//             {fields.map((field) => (
//               <Grid item xs={12} key={field.name}>
//                 <CareTextField
//                   label={field.label}
//                   name={field.name}
//                   control={control}
//                   errors={errors}
//                   getValues={getValues}
//                   icon={React.cloneElement(field.icon, { size: isMobile ? 14 : 16 })}
//                   size={isMobile ? 'small' : 'medium'}
//                   multiline={field.label.includes('Action')}
//                   minRows={field.label.includes('Action') ? 2 : 1}
//                 />
//               </Grid>
//             ))}
//           </Grid>
//         ) : (
//           <Grid container spacing={spacing}>
//             {fields.map((field) => {
//               const value = getNestedValue(carePlan, field.name);
//               return (
//                 <Grid item xs={12} key={field.name}>
//                   <Box
//                     sx={{
//                       display: 'flex',
//                       alignItems: 'flex-start',
//                       gap: 1,
//                       p: isMobile ? 1 : 1.5,
//                       backgroundColor: theme.palette.background.default,
//                       borderRadius: 1,
//                       minHeight: isMobile ? 56 : 64,
//                       transition: 'all 0.2s ease',
//                       '&:hover': {
//                         backgroundColor: theme.palette.action.hover
//                       }
//                     }}
//                   >
//                     <Box
//                       sx={{
//                         display: 'flex',
//                         alignItems: 'center',
//                         justifyContent: 'center',
//                         backgroundColor: theme.palette.warning.light,
//                         color: theme.palette.warning.contrastText,
//                         borderRadius: '50%',
//                         width: isMobile ? 32 : 36,
//                         height: isMobile ? 32 : 36,
//                         flexShrink: 0,
//                         mt: 0.5
//                       }}
//                     >
//                       {React.cloneElement(field.icon, {
//                         size: isMobile ? 14 : 16
//                       })}
//                     </Box>
//                     <Box sx={{ overflow: 'hidden', flex: 1 }}>
//                       <Typography
//                         variant={isMobile ? 'caption' : 'subtitle2'}
//                         sx={{
//                           fontWeight: 500,
//                           color: theme.palette.text.secondary,
//                           lineHeight: 1.2
//                         }}
//                       >
//                         {field.label}
//                       </Typography>
//                       <Typography
//                         variant={isMobile ? 'body2' : 'body1'}
//                         sx={{
//                           fontWeight: 400,
//                           color: theme.palette.text.primary,
//                           whiteSpace: 'pre-wrap',
//                           wordBreak: 'break-word'
//                         }}
//                       >
//                         {value}
//                       </Typography>
//                     </Box>
//                   </Box>
//                 </Grid>
//               );
//             })}
//           </Grid>
//         )}
//       </Box>
//     </Box>
//   );
// };

// export default ContingencyPlanSection;
import { Box, Typography, useTheme, Grid, IconButton, Button } from '@mui/material';
import React from 'react';
import {
  FaExclamationCircle,
  FaFirstAid,
  FaShieldAlt,
  FaStickyNote,
  FaTrash,
  FaPlus
} from 'react-icons/fa';
import { useFieldArray } from 'react-hook-form';
import {
  SectionProps,
  CarePlanFieldPath,
  ContingencyAndDisasterPlan
} from '../../../../types/ndisSection/carePlanInfoTypes';
import { CareTextField, SectionHeader } from '../Components';

const ContingencyPlanSection: React.FC<SectionProps> = ({
  editMode,
  isMobile,
  handleEditToggle,
  handleSubmit,
  handleCancel,
  control,
  errors,
  getValues
}) => {
  const theme = useTheme();
  const spacing = isMobile ? 1 : 2;

  const { fields, append, remove } = useFieldArray({
    control,
    name: 'ContingencyAndDisasterPlan'
  });

  const defaultPlan: ContingencyAndDisasterPlan = {
    Scenario: '',
    RiskLevel: '',
    ImmediateAction: '',
    OngoingAction: ''
  };

  // Normalize ContingencyAndDisasterPlan to always be an array
  const normalizeContingencyPlan = (
    plan: ContingencyAndDisasterPlan | ContingencyAndDisasterPlan[] | undefined
  ): ContingencyAndDisasterPlan[] => {
    if (!plan) {
      return [defaultPlan];
    }
    if (!Array.isArray(plan)) {
      return [plan];
    }
    return plan.length > 0 ? plan : [defaultPlan];
  };

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.background.paper,
        borderRadius: 2,
        boxShadow: theme.shadows[1],
        overflow: 'hidden',
        width: '100%',
        maxWidth: '100%',
        mx: 'auto'
      }}
    >
      <SectionHeader
        icon={<FaExclamationCircle size={isMobile ? 16 : 20} />}
        title="Contingency & Disaster Plan"
        color={theme.palette.warning.dark}
        editMode={editMode}
        handleEditToggle={handleEditToggle}
        handleSubmit={handleSubmit}
        handleCancel={handleCancel}
        getValues={getValues}
      />

      <Box sx={{ p: isMobile ? 1 : 2 }}>
        {editMode ? (
          <>
            {fields.map((item, index) => (
              <Grid container spacing={spacing} key={item.id} sx={{ mb: 2 }}>
                {[
                  { label: 'Scenario', icon: <FaFirstAid />, key: 'Scenario' },
                  { label: 'Risk Level', icon: <FaShieldAlt />, key: 'RiskLevel' },
                  { label: 'Immediate Action', icon: <FaStickyNote />, key: 'ImmediateAction' },
                  { label: 'Ongoing Action', icon: <FaStickyNote />, key: 'OngoingAction' }
                ].map((field) => (
                  <Grid item xs={12} key={field.key}>
                    <CareTextField
                      label={field.label}
                      name={
                        `ContingencyAndDisasterPlan[${index}].${field.key}` as CarePlanFieldPath
                      }
                      control={control}
                      errors={errors}
                      getValues={getValues}
                      icon={React.cloneElement(field.icon, { size: isMobile ? 14 : 16 })}
                      size={isMobile ? 'small' : 'medium'}
                      multiline={field.key.includes('Action')}
                      minRows={field.key.includes('Action') ? 2 : 1}
                    />
                  </Grid>
                ))}
                <Grid item xs={12} textAlign="right">
                  <IconButton onClick={() => remove(index)} color="error">
                    <FaTrash />
                  </IconButton>
                </Grid>
              </Grid>
            ))}
            <Button
              startIcon={<FaPlus />}
              variant="outlined"
              onClick={() => append(defaultPlan)}
              sx={{ mt: 1 }}
            >
              Add Plan
            </Button>
          </>
        ) : (
          <>
            {normalizeContingencyPlan(getValues('ContingencyAndDisasterPlan')).map(
              (item, index) => (
                <Grid container spacing={spacing} key={index} sx={{ mb: 2 }}>
                  {[
                    { label: 'Scenario', value: item?.Scenario, icon: <FaFirstAid /> },
                    { label: 'Risk Level', value: item?.RiskLevel, icon: <FaShieldAlt /> },
                    {
                      label: 'Immediate Action',
                      value: item?.ImmediateAction,
                      icon: <FaStickyNote />
                    },
                    { label: 'Ongoing Action', value: item?.OngoingAction, icon: <FaStickyNote /> }
                  ].map((field, i) => (
                    <>
                      <hr />
                      <Grid item xs={12} key={i}>
                        <Box
                          sx={{
                            display: 'flex',
                            alignItems: 'flex-start',
                            gap: 1,
                            p: isMobile ? 1 : 1.5,
                            backgroundColor: theme.palette.background.default,
                            borderRadius: 1,
                            transition: 'all 0.2s ease',
                            '&:hover': {
                              backgroundColor: theme.palette.action.hover
                            }
                          }}
                        >
                          <Box
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              backgroundColor: theme.palette.warning.light,
                              color: theme.palette.warning.contrastText,
                              borderRadius: '50%',
                              width: isMobile ? 32 : 36,
                              height: isMobile ? 32 : 36,
                              flexShrink: 0,
                              mt: 0.5
                            }}
                          >
                            {React.cloneElement(field.icon, { size: isMobile ? 14 : 16 })}
                          </Box>
                          <Box sx={{ overflow: 'hidden', flex: 1 }}>
                            <Typography
                              variant={isMobile ? 'caption' : 'subtitle2'}
                              sx={{ fontWeight: 500, color: theme.palette.text.secondary }}
                            >
                              {field.label}
                            </Typography>
                            <Typography
                              variant={isMobile ? 'body2' : 'body1'}
                              sx={{
                                fontWeight: 400,
                                color: theme.palette.text.primary,
                                whiteSpace: 'pre-wrap',
                                wordBreak: 'break-word'
                              }}
                            >
                              {field.value || 'Not provided'}
                            </Typography>
                          </Box>
                        </Box>
                      </Grid>
                    </>
                  ))}
                </Grid>
              )
            )}
          </>
        )}
      </Box>
    </Box>
  );
};

export default ContingencyPlanSection;